module.exports = __webpack_public_path__ + "static/BigBang_UAU_NSZ_clip-8f6ba6dae61c09bb51d29ec1be721481.mp4";